import LogRocket from "logrocket";
import { logRocketConfig } from "src/config/config";
import logger from "src/utils/logger/logger";

export const useTools = () => {
  logger.log("[vf-dl] LogRocketId:", logRocketConfig.appId);
  if (logRocketConfig && logRocketConfig.isEnabled && logRocketConfig.appId) LogRocket.init(logRocketConfig.appId);
};
